/**
 * Русское склонение числительных: «1 позиция», «4 позиции», «12 позиций».
 *
 * До «Шахмат» раскладов было по четыре, и строка «${n} позиции» работала
 * случайно — на четырёх она верна. Расклады на шесть и двенадцать позиций
 * сразу выдали «6 позиции», и это ровно тот сорт мелочи, по которой видно,
 * что текст в интерфейсе собран из кусков.
 */
export function plural(count: number, one: string, few: string, many: string): string {
  const abs = Math.abs(count) % 100;
  const tail = abs % 10;
  if (abs > 10 && abs < 20) return many;
  if (tail > 1 && tail < 5) return few;
  if (tail === 1) return one;
  return many;
}

/** Число вместе со склонённым словом: «12 позиций». */
export const pluralize = (count: number, one: string, few: string, many: string): string =>
  `${count} ${plural(count, one, few, many)}`;
